import React , { useEffect } from "react";
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { Box, LinearProgress, Typography, Breadcrumbs, Tooltip, Fab, CardContent, Grid, Drawer } 
from '@mui/material';
import But from '@mui/material/Button'
import { useTheme } from "@mui/material/styles";
import CardFooter from "../../components/Card/CardFooter.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardBody from "../../components/Card/CardBody";
import CustomTabs from "../../components/CustomTabs/CustomTabs.jsx";
//import Table from "components/Table/Table.jsx";
import DoneIcon from '@mui/icons-material/Done';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
//import Table from "@mui/material/Table";
import Skeleton from "@mui/material/Skeleton"
import { baseUrl } from '../../components/shared/baseUrl';
import {useSelector} from 'react-redux'





const styles = (theme) =>({
    cardCategoryWhite: {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    cardTitleWhite: {
      color: "#FFFFFF",
      marginTop: "0px",
      minHeight: "auto",
      fontWeight: "300",
      fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
      marginBottom: "3px",
      textDecoration: "none",
      align: "center"
    },
    list: {
        width: 250,
      }
  });

  var cla = {
    "_id":"6006f33eef2c0d65ccbf6601",
    "title": "Class IX",
    "teacherId":"5fe192d970d8c633c005da24",
    "sessionActive":false,
    "image":"assets/images/cimage.jpg",
    "std":"IX"
  }


    export default function ViewStudentClass(props) {

        const [clas, setclas] = React.useState([]);
        const [loading, setloading] = React.useState(true);
        const [sess, setsess] = React.useState([]);
        const [state, setState] = React.useState(false);
        const [sdetail, setsdetail] = React.useState({"title":'',"modId":''});
        const user = useSelector(state => state.user)
        const [profile, setprofile] = React.useState('');
        const { classId } = useParams();



        useEffect(() => {

            const CancelToken = axios.CancelToken;
            const source = CancelToken.source();

            
            const loadData=()=>{

              axios.get(`${baseUrl}pyinterpreter/profile/email/${user.email}`)
              .then((response) => {                
                  console.log('Old user')
                  
                  setprofile(response.data)
                  console.log(`${baseUrl}class/${classId}`)
                  axios.get(`${baseUrl}class/${classId}`, { cancelToken: source.token })
                  .then((response) => {
                    console.log('Class loading')
                    console.log(response)
                  setclas(response.data)
                  const dat = Array.from(response.data.sessions)
                  setsess(dat)
                  setloading(false)
    
              })
              .catch((error)=>{
              console.log(error);
              });
                
              })  
            
            }
            loadData();
            return () => {
                source.cancel();
            };

        }, []);
        //console.log(sess);

        const history = useNavigate();

        const handleStartSession = (Id) => {
          if(profile[0].preTest[0].completed==false){
            if(profile[0].sessionId!=''){                       
              history(`/student/dashboard/viewstudentclass/${classId}/session/${profile[0]._id}/activitypretest`)
             }
             else{
              profile[0].sessionId=Id
              const mdata=
              {
                profile: profile[0]
              }                     
              console.log(mdata)
        
              axios.put(`${baseUrl}pyinterpreter/profile/save/${profile[0]._id}`, mdata)
              .then((response) => {
                  console.log(response.data)
                  const activity = response.data
                  setprofile(activity)
                  history(`/student/dashboard/viewstudentclass/${classId}/session/${profile[0]._id}/activitypretest`)
              })
            }
          }
          else{
          if(profile[0].sessionId!=''){                       
           history(`/student/dashboard/viewstudentclass/${classId}/session/${Id}/profile/${profile[0]._id}/scenario`)
          }
          else{
          
          profile[0].sessionId=Id
     
     
           const mdata=
           {
             profile: profile[0]
           }                     
           console.log(mdata)
     
           axios.put(`${baseUrl}pyinterpreter/profile/save/${profile[0]._id}`, mdata)
           .then((response) => {
               console.log(response.data)
               const activity = response.data
               setprofile(activity)
               history(`/student/dashboard/viewstudentclass/${classId}/session/${Id}/profile/${profile[0]._id}/scenario`)
           })
           
         }
        }
       }
          
    

     //console.log(sdetail)
    
        function datepartial(date){
            
            var st = new Date(date).toString();
            return(
                st.substring(0, 21)
            );
        }

       function RenderSessionItem(mod){
            return(
              <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>

                             <Card hoverable onClick={() => handleStartSession(mod._id)} style={{border: "1px solid red"}}>
                                  <CardContent>
                                      <img alt={`${mod.title}`} className="card-img-top" src={baseUrl+mod.image} />
                                    <Typography gutterBottom variant="h6" component="h4">
                                            {mod.title}
                                    </Typography>
                                    <Typography component="h5" variant="caption"> 
                                     {mod.completed===false ? ' Status: active' : ' Status: inactive' } |
                                     Start Date: {datepartial(mod.start)}

                                    </Typography>                                    
                                  </CardContent>  
                            </Card>
        
              </Link>
            );
          }     
    const theme = useTheme()
    const classes = styles(theme);

    console.log(profile)

    const studentlist = clas.students;
    //console.log(clas)

    const teacherlist = clas.coTeachers;
    const slist=clas.sessions;
    const sessionlist = sess
    if(JSON.stringify(sessionlist)==='[]'){
        console.log('NO session added')
    }
   // console.log(sessionlist);

    const sesslist=sessionlist.map((ses) => {

        return (
                <GridItem xs={12} sm={6} md={3} key={ses._id}>
                    
                    {RenderSessionItem(ses)}

                  </GridItem>
                  
                  
            );
          
        });

    
    return(

        (loading!==true?

        <GridContainer>
            <GridItem xs={12} sm={12} md={3}>

            <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
                <Link color="inherit" to="/student/dashboard">
                        Dashboard
                </Link>
                <Typography color="textPrimary">{clas.title}</Typography>
            </Breadcrumbs>
            </GridItem>
            
        <GridItem xs={12} sm={12} md={12}>
          <CustomTabs
            title="Sessions:"
            headerColor="rose"
            tabs={[
              {
                tabName: "Active Inquiry Sessions",
                tabIcon: SettingsBackupRestoreIcon,
                 tabContent: 
                (
                <Grid>
                  <Grid container spacing={4}>
                      {JSON.stringify(sessionlist)!=='[]'? sesslist:<p>No Session added</p>}
                  </Grid>
                </Grid>

                )
              },
              {
                tabName: "Completed sessions",
                tabIcon: DoneIcon,
                tabContent: (
                
                   <p>This tab contains completed sessions</p>


                )
              }
            ]}
          />
        </GridItem>


        <GridItem xs={12} sm={12} md={4}>
                <Card style={{border: "1px solid black"}}>
                  <CardHeader color="rose" align="center">
                      <h4 className={classes.cardCategoryWhite}> About Class </h4>
                  </CardHeader>
                  <CardBody>
                      <p>standard: {clas.std}</p>
                                       {/* <Button
                                        onClick={handleStartSession}
                                        className={classes.backButton}
                                      >
                                        Direct
                                      </Button> */}

                  </CardBody>
                </Card>
            </GridItem>

        </GridContainer>:<GridContainer spacing={3}>
            <GridItem xs={12} sm={12} md={12}>
              <Skeleton variant="text" /> 
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <Skeleton variant="text" /> 
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <Box sx={{ width: 420, marginRight: 2, my: 5, padding: 2 }}>
                <Skeleton animation="wave" variant="rectangular" width={420} height={300} />    
              </Box>
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
              <Box sx={{ width: 420, marginRight: 2, my: 5 }}>
                <Skeleton animation="wave" variant="rectangular" width={420} height={300} />    
              </Box> 
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
              <Box sx={{ width: 420, marginRight: 2, my: 5 }}>
                <Skeleton variant="circular" width={420} height={300} />    
              </Box> 
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <Skeleton variant="text" /> 
            </GridItem> 
          </GridContainer>
      )

    );
}